// Excel template + import for a whole area's ghars, pathis and SR/SK.
import * as XLSX from "xlsx";
import { hinglishToHindi } from "./translit";
import { splitTitle } from "../data/rssbData";

export function downloadAreaTemplate() {
  const wb = XLSX.utils.book_new();
  const add = (rows, name) => XLSX.utils.book_append_sheet(wb, XLSX.utils.aoa_to_sheet(rows), name);
  add([["Name", "Type (C/SC/SP)", "Days (Sun/Wed/Thu)"], ["Example Ghar", "C", "Sun, Thu"]], "Satsang Ghar");
  add([["Title (Shri/Smt/Kumari)", "Name", "Place", "Mobile"], ["Shri", "Example Name", "Example Place", ""]], "Pathi");
  add([["Title (Shri/Smt/Kumari)", "Name", "Role (SR/SK)", "Place", "Mobile"], ["Smt", "Example Name", "SR", "Example Place", ""]], "SR-SK");
  XLSX.writeFile(wb, "area_template.xlsx");
}

const col = (row, ...keys) => {
  const k = Object.keys(row).find((h) => keys.some((x) => h.toLowerCase().includes(x)));
  return k ? String(row[k] ?? "").trim() : "";
};
const titleOf = (t) =>
  /smt|shrimati|mrs|श्रीमती/i.test(t) ? "श्रीमती" : /km|kumari|miss|कुमारी/i.test(t) ? "कुमारी" : /sh|sri|mr|श्री/i.test(t) ? "श्री" : "";
const typeOf = (t) => {
  const s = t.toLowerCase();
  if (/point|sp|स\.प/.test(s)) return "SP";
  if (/sub|sc|स\.स/.test(s)) return "SC";
  return "C";
};
const daysOf = (t) => {
  const d = [];
  if (/sun|ravi|रवि/i.test(t)) d.push(0);
  if (/wed|budh|बुध/i.test(t)) d.push(3);
  if (/thu|guru|गुरु/i.test(t)) d.push(4);
  return d.length ? d : [0];
};
const LATIN_TITLE = /^(shrimati|smt|mrs|kumari|km|miss|shri|sri|sh|mr)\.?\s+/i;

async function personFrom(row) {
  let raw = col(row, "name", "नाम");
  if (!raw) return null;
  let title = titleOf(col(row, "title", "संबोधन"));
  const m = raw.match(LATIN_TITLE);
  if (m) {
    title = title || titleOf(m[1]);
    raw = raw.slice(m[0].length);
  }
  const split = splitTitle(await hinglishToHindi(raw));
  const place = col(row, "place", "स्थान", "locality", "city");
  return {
    hi: split.rest,
    en: /[A-Za-z]/.test(raw) ? raw : split.rest,
    title: title || split.title || "श्री",
    placeHi: place ? await hinglishToHindi(place) : "",
    mobile: col(row, "mobile", "contact", "phone", "मोबाइल"),
    group: 1,
  };
}

export async function parseAreaFile(file) {
  const wb = XLSX.read(await file.arrayBuffer(), { type: "array" });
  const out = { ghars: [], pathis: [], preachers: [] };
  const stamp = Date.now().toString(36);
  for (const sheetName of wb.SheetNames) {
    const rows = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], { defval: "" });
    const n = sheetName.toLowerCase();
    if (/ghar|घर/.test(n)) {
      for (const [i, r] of rows.entries()) {
        const raw = col(r, "name", "नाम");
        if (!raw) continue;
        out.ghars.push({ id: `g${stamp}${i}`, hi: await hinglishToHindi(raw), en: raw, type: typeOf(col(r, "type", "प्रकार")), group: 1, days: daysOf(col(r, "day", "दिन")) });
      }
    } else if (/pathi|पाठी/.test(n)) {
      for (const [i, r] of rows.entries()) {
        const p = await personFrom(r);
        if (p) out.pathis.push({ id: `p${stamp}${i}`, ...p });
      }
    } else if (/sr|sk|reader|karta/.test(n)) {
      for (const [i, r] of rows.entries()) {
        const p = await personFrom(r);
        if (p) out.preachers.push({ id: `s${stamp}${i}`, ...p, role: /sk|karta|कर्ता/i.test(col(r, "role", "भूमिका")) ? "SK" : "SR" });
      }
    }
  }
  return out;
}
